export const pageModule = {

    state() {
        return {
            contact: { data: null, uk: null, ru: null },
            about: null,
        }
    },

    getters: {
        contact(state) {
            return state.contact
        },
        about(state) {
            return state.aboutUs
        },
    },

    mutations: {
        setContact(state, data) {
            state.contact.data = data.data
            state.contact.ru = data.ru
            state.contact.uk = data.uk
        },

        setAbout(state, data) {
            state.aboutUs = data[0]
        },

    },

    actions: {
        async getContactPage({ commit }) {
            await axios.get('/api/page-contact').then((res) => {
                commit('setContact', res.data);
            }).catch((err) => {

            })
        },
        async getAboutUsPage({ commit }) {
            await axios.get('/api/page-about-us').then((res) => {
                commit('setAbout', res.data);
            }).catch((err) => {

            })
        },
    },

    namespaced: true,
}